import React from "react";
import "../../assets/generalTrade.css";

const GeneralTradeAbout: React.FC = () => {
  return (
    <main className="gt-page">
      <section className="gt-page-banner">
        <div className="gt-container">
          <span className="gt-eyebrow">About Us</span>
          <h1>Connecting quality products with the right customers</h1>
        </div>
      </section>

      <section className="gt-content-section">
        <div className="gt-container gt-about-grid">
          <div>
            <h2>Lyra Zone General Trading</h2>
            <p>
              We connect products with households, retailers and communities
              through focused customer engagement, strong retail relationships,
              direct market outreach and promotional activities.
            </p>
            <p>
              Our goal is to build awareness, encourage product trials and
              develop lasting customer trust while supporting reliable product
              availability across the market.
            </p>
          </div>

          <div className="gt-about-points">
            <article><h3>Retail Engagement</h3><p>Building relationships with supermarkets, grocery stores and local retailers.</p></article>
            <article><h3>Direct Customer Reach</h3><p>Connecting quality everyday essentials with households and communities.</p></article>
            <article><h3>Digital Outreach</h3><p>Increasing product visibility and customer engagement through digital channels.</p></article>
            <article><h3>Customer Feedback</h3><p>Listening to customers and retail partners to continuously improve service.</p></article>
          </div>
        </div>
      </section>
    </main>
  );
};

export default GeneralTradeAbout;
